import dice from "assets/dice.mp3";
import { AudioPlayer } from "./audioplayer";

export const soundDice = new AudioPlayer({
  src: dice,
  autoplay: false,
  loop: false,
  volume: 0.2,
  enableWebAudioGain: true,
  disableMesureMetric: true,
});

const minimumDb = 50;
export const linearToScaledDb = (linear: number): number => {
  // convert linear volume to dB and scale to 0-1 (corresponding to -50dB to 0dB)
  if (linear === 0) return 0;
  const db = 20 * Math.log10(linear);
  const rangedDb = (db + minimumDb) / minimumDb;
  if (rangedDb > 1) return 1;
  if (rangedDb < 0) return 0;
  return rangedDb;
};

export const scaledDbToLinear = (db: number): number => {
  // convert dB volume to linear ratio 0-1
  if (db === 0) return 0;
  const linear = Math.pow(10, (db * minimumDb - minimumDb) / 20);
  if (linear > 1) return 1;
  if (linear < 0) return 0;
  return linear;
};
